import apiUrl from '../assets/apiUrl';

interface additionalParams {
	auth: boolean;
	token: string;
}

const download = async (
	url: string,
	filename: string,
	size: number,
	additionalParams?: additionalParams
) => {
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;

	// add the link to the document
	document.body.appendChild(link);

	// programmatically click on the link to trigger the download
	link.click();

	// remove the link from the document after the download has started
	document.body.removeChild(link);
};

const remove = async (
	file_uid: string,
	token: string,
	callback: () => void
) => {
	await fetch(`${apiUrl}/file/${file_uid}`, {
		method: 'DELETE',
		headers: { 'x-access-token': token },
	});
	callback();
};

export { download, remove };
